export const DISCORD_INVITE_URL = 'https://discord.gg/PN9AmJK7D'
export const GITHUB_REPO_URL = 'https://github.com/creativeplatform/pixels'
